<template>
	<div>
		<div ref="pdfContent" class="print-track-expression-answer">
			<div class="track-title">{{ title }}</div>
			<div class="text-block">
				<div class="original-text-block">
					<p class="version-text">Version Originale</p>
					<div v-html="originalText" class="ql-editor answer-block"></div>
				</div>

				<div class="correction-text-block">
					<p class="version-text">Version Corrigé</p>
					<div v-html="formattedText" class="ql-editor answer-block"></div>
				</div>
			</div>
		</div>
		<Loading :show="loading" label="1 2 3 ..." />
	</div>
</template>

<script>
import Loading from 'vue-full-loading';
import { generateKeyForStorage } from '@/utils/download-expression-answer';
import { downloadPdf } from '@/utils/jspdf';
export default {
	name: 'PrintTrackExpressionAnswer',
	components: { Loading },
	data() {
		return { loading: false, formattedText: '', originalText: '', title: '', fileName: '' };
	},
	async mounted() {
		this.loading = true;
		try {
			await this.loadData();
			this.loading = false;

			this.$nextTick(async () => {
				await this.startDownloadPdf(this.fileName);
				window.close();
			});
		} catch (error) {
			console.error('Error fetching data from localStorage:', error);
		}
	},
	methods: {
		async fetchSession(sessionId) {
			if (!sessionId) return;

			const session = await this.$store.dispatch('sessions/getSessionDetail', {
				sessionId,
			});

			this.session = session;

			return session;
		},
		async fetchUserData() {
			return await this.$store.dispatch('profile/getUserByFormationId', {
				idFormation: this.$route.params.formationId,
			});
		},
		generateFileName(user, session, sessionBlock, questionnaire, track) {
			const fileName = `${user.first_name}-${user.last_name}-${session.title}-${sessionBlock.tag_display}-${track.position}/${questionnaire.tracks.length}`;
			this.fileName = fileName;
		},
		findTrackAndParents(session, trackId) {
			for (const sessionBlock of session.sessionBlocks) {
				for (const questionnaire of sessionBlock.questionnaires) {
					for (const track of questionnaire.tracks) {
						if (track._id === trackId) {
							return {
								track: track,
								questionnaire: questionnaire,
								sessionBlock: sessionBlock,
							};
						}
					}
				}
			}
			return null;
		},
		generateTitle(sessionBlock, questionnaire, track) {
			const title = `${track.title} - ${sessionBlock.tag_display} ${track.position}/${questionnaire.tracks.length}`;
			this.title = title;
		},
		getAndSetDataFromLocalStorage() {
			const key = generateKeyForStorage(
				this.$route.params.formationId,
				this.$route.params.sessionId,
				this.$route.params.sessionBlockId,
				this.$route.params.trackId
			);
			const data = window.localStorage.getItem(key);

			if (data == null) return;

			const parsedData = JSON.parse(data);
			this.formattedText = parsedData.formattedText;
			this.originalText = parsedData.originalText;

			window.localStorage.removeItem(key);
		},
		async loadData() {
			const [session, user] = await Promise.all([
				this.fetchSession(this.$route.params.sessionId),
				this.fetchUserData(),
			]);
			if (session == null) return;

			const result = this.findTrackAndParents(session, this.$route.params.trackId);
			if (result == null) return;

			this.generateTitle(result.sessionBlock, result.questionnaire, result.track);
			this.getAndSetDataFromLocalStorage();
			this.generateFileName(user, session, result.sessionBlock, result.questionnaire, result.track);
		},
		async startDownloadPdf(fileName) {
			await downloadPdf(fileName, this.$refs.pdfContent);
		},
	},
};
</script>

<style lang="scss" scoped>
.track-title {
	font-weight: bold;
	font-size: 2.3rem;
	margin-bottom: 50px;
}

.print-track-expression-answer {
	width: 794px;
	/* overflow-wrap: break-word;
	word-break: break-word; */
	padding-top: 20px;

	.text-block {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.original-text-block {
		margin-bottom: 110px;
	}

	.answer-block {
		padding: 0 3rem;
	}

	.version-text {
		font-weight: bold;
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}

	::v-deep {
		p {
			margin-bottom: 0 !important;
		}

		.highlight-error {
			border-bottom: 2px solid var(--tag-violet-primary);
		}

		.highlight-selected-error {
			background-color: #b1a0ef;
			border-bottom: 2px solid var(--tag-violet-primary);
			color: white;
		}
		.highlight-keyword {
			background-color: var(--tag-green-primary);
			color: white;
			border-radius: 2px;
		}
	}
}
</style>
